import React, { Component } from 'react';
import { render } from 'react-dom';
import Navbarmenu from './Navbarmenu';
import './RolebasedContent.css';
import Container from '@material-ui/core/Container';
// import data from '../data/data.json';
import data from '../data/ApplicationDevelopment.json'
// import data from '../data/RoleFamilies.json'


class RoleBasedContent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			RoleFamilies : [],
			Roles : [],
			cities : [],
      level:[],
      filteredData: [],
			selectedCountry : '--Choose Country--',
			selectedState : '--Choose State--',
      selectedCity:'---choose city--',
      levelPlaceHolderValue:'--Level--'
		};
		this.changeCountry = this.changeCountry.bind(this);
		this.changeState = this.changeState.bind(this);
	}
  
	componentDidMount() {
		this.setState({
			RoleFamilies : [
				{ name: 'Application Development', 
        Roles: [
           {name: 'Application Development Analyst',level:['11'] },
           {name: 'Application Development Sr Analyst', level:['10']},
           {name: 'Application Development Senior Manager', level:['6']}
            ] },
				{ name: 'Software Engineering', 
        Roles: [ 
          {name: 'Software Engineering Analyst',level:['11']},
           {name: 'Software Engineering Sr Analyst', level:['10,12']},

               ] },


				// { name: 'USA', Roles: [ {name: 'C', cities: ['Downers Grove']} ] },
				// { name: 'Mexico', Roles: [ {name: 'D', cities: ['Puebla']} ] },
				// { name: 'India', Roles: [ {name: 'E', cities: ['Delhi', 'Kolkata', 'Mumbai', 'Bangalore']} ] },
			]
		});
	}
  
//   data.payload.map((payload) => {
//     return payload.brands.map(brand =>{
//         return brand.subProducts.map(subProduct => {
//           return `${payload.name}, ${brand.name}, ${subProduct.name}`
//         }).join("\n")
//     }).join("\n")
// }).join("\n")



  


	changeCountry(event) {
		this.setState({
      selectedCountry: event.target.value, 
      Roles : Array.from(this.state.RoleFamilies.find(cntry => cntry.name === event.target.value).Roles),
      level: []
    },
      ()=>console.log(this.state.Roles)  
      
      );
		
// this.setState({Roles : Array.from(this.state.RoleFamilies.find(cntry => cntry.name === event.target.value).Roles)},()=>console.log(this.state.Roles) );
// this.setState({Roles : this.state.RoleFamilies.find(cntry => cntry.name === event.target.value).Roles});
  //  console.log("from country change map ", this.state.Roles);

  //  this.setState({ Roles : Array.from(new Set(this.state.RoleFamilies.map(element => element[event.target.value]))) }) 
   
  //  let options = Array.from(new Set(this.state.RoleFamilies.map(element => element[e])));
    //console.log("from country change ",this.state.Roles);
	}

	// changeState(event) {
	// 	this.setState({selectedState: event.target.value,
  //   level: Array.from(this.state.Roles.find((level,index) => level.name === event.target.value).level)},
  //   ()=>console.log(this.state.level)   
  //    );
    
  
	// 	// const stats = this.state.RoleFamilies.find(cntry => cntry.name === this.state.selectedCountry).Roles;
	// 	// this.setState({cities : stats.find(stat => stat.name === event.target.value).cities});
	// }


  changeState(event) {

    let levelArray =  Array.from(this.state.Roles.find(level => level.name === event.target.value).level);
    let levelPlaceHolderValue = "--SelectCity--";
    if(levelArray.length === 1){

      levelPlaceHolderValue = levelArray[0];

    }

    let value = event.target.value;

    console.log ("From filter",value);
    if(value) {
      // let { filterOption } = this.state;
      // let filteredData = data.filter(element => element[filterOption] == value);
      let filteredData = data.filter(element => element.Role === value);
      console.log ("From filter comparison Filtered data lenght",filteredData.length);
      
    }

    
    this.setState({

      selectedState: event.target.value,

      level:levelArray,

      levelPlaceHolderValue :levelPlaceHolderValue,

      filteredData: data.filter(element => element.Role === value)
  },

      ()=>{

        console.log(this.state.level);

      }  

    );



  }


  renderTableData(data) {
    return data.map((element, i) => (
      <tr key={i}> 
        <td>{element.CourseName}</td>
        <td>{element.Duration}</td>
        <td>{element.DLF}</td> 
      </tr>
    ))
  }


 
    render() {
      let { filterOption, filteredData } = this.state
      return (
        <>
        <div className="main-container" id="rolebasedcontent-box">
            <title>Security Learning - Role based</title>
            <img src={process.env.PUBLIC_URL +"/images/entry-level-banner.png"} className="banner-img"/>
            {/* <Navbarmenu/> */}
        </div>
        <Container className='role-based-container' maxWidth="xl">
            <div className="role-based-wrap">
                <p>Here is the opportunity to equip yourself with the security skills required for your day-to-day activities and beyond. There is a guidance provided for your career level and the respective role. This is not a limitation while you can explore more. Select career level and role you are playing to get the security learning guidance.</p>
            </div>
            <div className="filter-container">

             
              <div>
                <label> Filter By</label>
                <select onChange={this.optionSelected.bind(this)}> 
                  <option value="RoleFamily">RoleFamily  </option>
                  {this.loadRoleFamilies('RoleFamily')}
                 
                </select>

                <select onChange={this.filterOptionSelected.bind(this)}> 
                  <option value="Role">Role </option>
                  {/* {data.map((result)=>(<option title={result.Role}>{result.Role}</option>)) */}
                  {this.loadRoles('Role')}
      
                </select>
                
                <select onChange={this.filterOptionSelected.bind(this)}> 
                  <option value="Level">Level  </option>
                  {this.renderFilterOptions(filterOption)}
                </select>

                <button onClick={()=>this.setState({ filteredData: [] })} className="reset-btn">Reset</button>



              </div>
              <table border="1">
                <thead>
                  <th> Courese Name</th>
                  <th> Age </th>
                  <th> City </th>
                </thead>
                <tbody>
                  {
                    filteredData.length? this.renderTableData(filteredData) : this.renderTableData(data) 
                  }
                </tbody>
              </table>
            </div>
        </Container>
        </>
      );
    }
  }
  
  export default RoleBasedContent;
//   render(<RolebasedContent />, document.getElementById('root'));


















// export default function RolebasedContent() {
//     return (
//         <>
//             <div className="main-container" id="rolebasedcontent-box">
//                 <title>Security Learning - Role based</title>
//                 <img src="/images/entry-level-banner.png" className="banner-img"/>
//                 <Navbarmenu/>
//             </div>
//             <Container className='role-based-container' maxWidth="xl">
//                 <div className="role-based-wrap">
//                     <p>Here is the opportunity to equip yourself with the security skills required for your day-to-day activities and beyond. There is a guidance provided for your career level and the respective role. This is not a limitation while you can explore more. Select career level and role you are playing to get the security learning guidance.</p>
//                 </div>
//             </Container>
//         </>
//     )
// }
